/**
 * 单文件的下载逻辑
 * @author huangshuo
 * time 2019-12-24
 */

import * as Util from 'js/util/util.js'
import { downloadFile } from '@filez/js-2-native'

const { getData } = require('js/api/getdata').default

/**
 * 单文件下载
 * @param data 单文件的meta对象
 * @param confirm 确认下载
 * @param callback 异常回调(用于探针检测的异常信息)
 */
function singleDownload(data, confirm = false, callback) {
  // 获取文件对象
  const fileData = data['0']
  // 获取url地址
  const downloadUrl = singleDownloadUrl(fileData)
  const iframeDownloadUrl = `${downloadUrl}&S=${window.store.getters.S}`
  // 确认是否不需要验证直接下载
  if (confirm) {
    if (Util.isClient()) { // client下载
      clientDownlaod(data)
    } else { // web下载
      webSingleDownload(iframeDownloadUrl)
    }
    return
  }
  // url中带probe，且不为空，是为了试探
  const probeUrl = `${downloadUrl}&probe=1`
  // 试探下载接口
  getData(probeUrl).then((res) => {
    if (Util.isClient()) { // client下载
      clientDownlaod(data)
    } else { // web下载
      webSingleDownload(iframeDownloadUrl)
    }
    // 成功下载的回调
    if (typeof callback === 'function') callback(true, res)
  }).catch((err) => {
    // 异常下载的回调
    if (typeof callback === 'function') callback(false, err)
  })
}


/**
 * 返回需要下载的url地址
 * @param data 单文件的meta对象
 */
function singleDownloadUrl(data) {
  // 设置请求参数
  const param = {}
  const baseURL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`
  const downloadFile = '/v2/dl_router/databox'

  // 组合请求参数
  let downloadparam
  // store存储的当前版本文件对象
  const storeCurFile = data
  // 组合请求参数
  param.path_type = storeCurFile.path_type
  param.path = storeCurFile.path
  param.from = storeCurFile.from
  param.neid = storeCurFile.neid
  param.rev = storeCurFile.rev == '' ? '' : storeCurFile.rev // 为空下载的未当前文件的最新版本

  // 获取用户数据信息
  param.account_id = store.getters.accountId
  param.uid = store.getters.uId
  downloadparam = `${param.path}?`
  for (const val in param) {
    downloadparam += `${val}=${param[val]}&`
  }
  // 删除最后一个&
  downloadparam = downloadparam.slice(0, downloadparam.length - 1)
  downloadparam = downloadparam.replace('\/\/', '\/')
  downloadparam = encodeURI(downloadparam)
  downloadparam = downloadparam.replace(/#/g, '%23')
  downloadparam = downloadparam.replace(/%/g, '%25')
  // 返回url地址
  return baseURL + downloadFile + downloadparam
}


/**
 * web端单文件的下载方式
 */
function webSingleDownload(url) {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.id = 'iframedownload'
  iframe.src = url
  iframe.frameborder = '0'
  document.body.appendChild(iframe)

  var timer = setInterval(() => {
    iframe = document.getElementById('iframedownload')
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
    // Check if loading is complete
    if (iframeDoc.readyState == 'complete' || iframeDoc.readyState == 'interactive') {
      clearInterval(timer)
    }
  }, 4000)
}

/**
 * 客户端的下载方式(单文件/多文件)
 */
function clientDownlaod(currentData) {
  const dlInfo = []
  if (currentData instanceof Array && currentData.length > 1) {
    for (let i = 0, len = currentData.length; i < len; i++) {
      dlInfo.push(currentData[i])
    }
  } else {
    dlInfo.push(currentData[0])
  }
  // 下载数据
  downloadFile({ remotePaths: dlInfo })
}


/**
 * 本地编辑的验证
 * @param data metadata
 */
function editCheck(fileData, callback) {
  // 获取url地址
  const downloadUrl = singleDownloadUrl(fileData)

  // url中带probe，且不为空，是为了试探
  const probeUrl = `${downloadUrl}&probe=1`
  // 试探下载接口
  getData(probeUrl).then((res) => {
    // 成功下载的回调
    if (typeof callback === 'function') callback(true, res)
  }).catch((err) => {
    // 异常下载的回调
    if (typeof callback === 'function') callback(false, err)
  })
}

// 导出方法
export { singleDownload, editCheck, singleDownloadUrl }
